import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features: {
    name: string;
    landing: boolean | string;
    profesional: boolean | string;
    avanzado: boolean | string;
  }[] = [{
    name: 'Diseno profesional',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Responsive',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Hosting por 1 ano',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Dominio por 1 ano',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Certificado SSL gratis',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'WhatsApp y Contacto',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Formulario de contacto',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Google Maps',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'SEO',
    landing: 'Basico',
    profesional: 'Optimizado',
    avanzado: 'Avanzado'
  }, {
    name: 'Secciones',
    landing: '3',
    profesional: '6',
    avanzado: '8'
  }, {
    name: 'Menu de navegacion',
    landing: false,
    profesional: true,
    avanzado: true
  }, {
    name: 'Galeria de fotos',
    landing: false,
    profesional: true,
    avanzado: true
  }, {
    name: 'Seccion de servicios',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Testimonios',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Redes sociales',
    landing: true,
    profesional: true,
    avanzado: true
  }, {
    name: 'Redaccion de textos',
    landing: 'Basica',
    profesional: 'Intermedia',
    avanzado: 'Completa'
  }, {
    name: 'Logotipo basico',
    landing: false,
    profesional: true,
    avanzado: true
  }, {
    name: 'Identidad visual basica',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Catalogo o menu digital',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Blog o noticias',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Reservas o citas online',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Animaciones y efectos',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Google Analytics',
    landing: false,
    profesional: false,
    avanzado: true
  }, {
    name: 'Soporte',
    landing: '30 dias',
    profesional: '60 dias',
    avanzado: '90 dias'
  }];
  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? <Check className="text-green-500 mx-auto" size={20} data-id="element-70" /> : <X className="text-red-500 mx-auto" size={20} data-id="element-71" />;
    }
    return <span className="text-nova-text-muted text-sm" data-id="element-72">{value}</span>;
  };
  return <section className="py-32 bg-nova-bg-alt" data-id="element-73">
      <div className="max-w-5xl mx-auto px-6" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-76">
            ¿Cual Plan Es Para Ti?
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4" data-id="element-77" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="overflow-x-auto" data-id="element-78">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-79">
            <thead data-id="element-80">
              <tr data-id="element-81">
                <th className="p-4 text-left text-nova-accent font-semibold border-b border-nova-card" data-id="element-82">
                  CARACTERISTICA
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-83">
                  LANDING
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-84">
                  PROFESIONAL
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-85">
                  AVANZADO
                </th>
              </tr>
            </thead>
            <tbody data-id="element-86">
              {features.map((feature, index) => <tr key={index} className={index % 2 === 0 ? 'bg-nova-card/50' : 'bg-transparent'} data-id="element-87">
                  <td className="p-4 text-nova-text-muted text-sm border-b border-nova-card/50" data-id="element-88">
                    {feature.name}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-89">
                    {renderValue(feature.landing)}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-90">
                    {renderValue(feature.profesional)}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-91">
                    {renderValue(feature.avanzado)}
                  </td>
                </tr>)}
              <tr className="bg-nova-card" data-id="element-92">
                <td className="p-4 font-bold text-nova-text" data-id="element-93">PRECIO</td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-94">
                  $597.000
                </td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-95">
                  $897.000
                </td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-96">
                  $1.497.000
                </td>
              </tr>
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}